<template>
  <f7-page name="permissions">
    <f7-navbar id="navbar" :title="$t('instructions')" color="black">
      <f7-nav-right>
        <CameraImage color="red"/>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small style="color:gray;">{{ $t('copyright') }}</small>
    </f7-toolbar>

    <f7-toolbar bottom>
      <small>{{$t('copyright')}}</small>
    </f7-toolbar>

    <f7-block>
      <Markdown :source="markdown" /> 
    </f7-block>

    <f7-list>
      <f7-list-item link="#" id="try_again" name="try_again" @click="try_again">{{ $t('permissions-try_again') }}</f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
  import { CameraImage } from '../icons-svg/icons-svg.js';
  import Markdown from 'vue3-markdown-it';

  export default {
    props: {
      f7router: Object,
      markdown: String,
    },
    components: {
      CameraImage,
      Markdown,
    },
    methods: {
      try_again() {
        const self=this;
        self.f7router.navigate('/register');  
      }
    },

  }

</script>

<style>
  img {
    max-width: 100%;
  }
</style>
